import React, { useContext, useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { CoreContext } from './context/index.js';
import './utils/logToSlack.js';
import 'lodash/get';
import { k as CHECKOUT } from './paths-ZKN3m62_.js';
import './product-_pRduMz7.js';
import { s as sendCartEvent } from './cart-bEN0otWy.js';
import 'lodash/cloneDeep';
import { d as dataLayerCheckoutAccor } from './checkout-17GMuD7V.js';
import { s as sendCartEventAccor, a as sendViewItemListEventAccor } from './cart-S5Bq_Aci.js';
import './helpers-qU2Vf3ni.js';
import { get } from 'lodash';
import 'cookies-next';
import './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import './payment-a4IKjS7g.js';
import { isAnyProductOutOfStock } from './utils/cart.js';
import Button from './components/Button/index.js';
import ButtonGroup from './components/ButtonGroup/index.js';
import { S as ShoppingCartItemDrawer } from './ShoppingCartItemDrawer-gwdYz9JE.js';
import { toggleModal } from './store/modal/index.js';
import { F as FeaturedProducts } from './FeaturedProducts-KkFxuCGR.js';
import Loader from './components/Loader/index.js';
import { formatPrice } from './utils/price.js';
import { c as classnames } from './index-2586sEvh.js';
import './animations--PMkOS0j.js';
import useAutoFocus from './hooks/useAutoFocus.js';
import './index-dEXHnASi.js';
import 'notistack';
import useItemListName from './hooks/useItemListName.js';

const ShoppingCartContentDrawer = ({ cart, isYmalLoading = false }) => {
    const { t: tCommon } = useTranslation('', { keyPrefix: '$common' });
    const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
    const { t: tValidation } = useTranslation('', { keyPrefix: '$common.$validation' });
    const { t: tCheckout } = useTranslation('', { keyPrefix: '$common.$pages.$checkout' });
    const router = useRouter();
    const ref = useAutoFocus({ tag: 'button' });
    const { push } = router;
    const locale = router.locale;
    const { data: { siteConfig: { productNameFilters, parentHotelCompany, siteName, cart: { ymalSlidesPerView = undefined, ymalBreakpoints = undefined, disableCartYmals = false, ymalFilterAddedProducts = true, drawerContinueShopping = false, drawerTotalInBUtton = false, } = {}, accorTagging: { accorTaggingEnabled = false } = {}, }, }, useDispatch, } = useContext(CoreContext);
    const dispatch = useDispatch();
    const itemListName = useItemListName('mini basket');
    const [itemsRendered, setItemsRendered] = useState(false);
    useEffect(() => {
        if (accorTaggingEnabled) {
            sendCartEventAccor({
                cart,
                siteFilters: productNameFilters,
                isViewCartEvent: true,
                affiliation: parentHotelCompany,
                brand: siteName,
            });
            sendViewItemListEventAccor({
                cart,
                siteFilters: productNameFilters,
                brand: siteName,
                itemListName,
            });
        }
        else {
            sendCartEvent({
                cart,
                locale,
                siteFilters: productNameFilters,
                isViewCartEvent: true,
                affiliation: parentHotelCompany,
                brand: siteName,
            });
        }
    }, []);
    useEffect(() => {
        if (cart.items.length > 0) {
            setItemsRendered(true);
        }
    }, [cart.items.length]);
    if (!cart.items.length)
        return (React.createElement("div", { className: "shopping-cart-list empty-cart", ref: ref },
            React.createElement("div", null, tValidation('cartEmpty')),
            React.createElement(ButtonGroup, { vertical: "always" },
                React.createElement(Button, { className: "empty-cart-btn", onClick: () => dispatch(toggleModal(null)) }, tButton('continueShopping')))));
    const isOutOfStock = isAnyProductOutOfStock(cart.items);
    const originalPrice = cart.prices.original_price;
    const currencyCode = originalPrice.currency;
    const subTotalPriceValue = get(cart, 'prices.subtotal_including_tax.value');
    const subTotalPriceText = formatPrice(subTotalPriceValue, currencyCode, locale);
    const totalPrice = (React.createElement(React.Fragment, null,
        React.createElement("span", { className: "space" }),
        subTotalPriceText));
    const onCheckoutClick = () => {
        if (accorTaggingEnabled) {
            dataLayerCheckoutAccor({
                cart,
                siteFilters: productNameFilters,
                affiliation: parentHotelCompany,
                brand: siteName,
                eventName: 'begin_checkout',
            });
        }
        dispatch(toggleModal(null));
        if (router.route === CHECKOUT) {
            return;
        }
        push(`/${locale}${CHECKOUT}`);
    };
    return (React.createElement("div", { className: "shopping-cart-content" },
        React.createElement("div", { className: "shopping-cart-list" },
            React.createElement("ul", { className: "body" }, cart.items.map(item => (React.createElement(ShoppingCartItemDrawer, { key: item.id, item: item })))),
            !disableCartYmals &&
                (!isYmalLoading ? (React.createElement(FeaturedProducts, { bottomControls: true, pagination: true, ymalSlidesPerView: ymalSlidesPerView, ymalBreakpoints: ymalBreakpoints, isReady: itemsRendered, cartItems: ymalFilterAddedProducts ? cart.items : undefined })) : (React.createElement(Loader, { center: true, padding: 48, size: 50 })))),
        React.createElement("div", { className: classnames('checkout-container', drawerTotalInBUtton && 'has-total'), ref: ref },
            React.createElement(ButtonGroup, { vertical: drawerContinueShopping ? 'never' : 'always' },
                drawerContinueShopping && (React.createElement(Button, { variant: "plain", onClick: () => dispatch(toggleModal(null)) }, tButton('continueShopping'))),
                React.createElement(Button, { disabled: isOutOfStock, disabledMsg: React.createElement(React.Fragment, null,
                        React.createElement("span", null, tCommon('outOfStock')),
                        React.createElement("span", null, tCheckout('beforeProceedingCheckout'))), toolTipVariant: "error", tooltipPosition: "top", className: "checkout-btn", onClick: onCheckoutClick },
                    tButton('toCheckout'),
                    drawerTotalInBUtton && totalPrice)))));
};

export { ShoppingCartContentDrawer as S };
//# sourceMappingURL=ShoppingCartContentDrawer-WknGx7eT.js.map
